import { gql } from "@apollo/client";

export const GET_SAVED_CLIPS = gql`
  query GetSavedClips(
    $userId: String!
    $sort: ClipSort
    $after: String
    $statuses: [ClipStatus!]
  ) {
    profile(query: $userId) {
      savedClipsCount
      clips(
        saved: true
        first: 20
        after: $after
        sort: $sort
        statuses: $statuses
      ) {
        pageInfo {
          hasNextPage
          endCursor
        }
        nodes {
          id
          internalId
          title
          thumbnailUrl(style: STANDARD)
          views
          createdAt
          saved {
            savedAt
          }
        }
      }
    }
  }
`;
